import { render, staticRenderFns } from "./org_question_list.vue?vue&type=template&id=d8f6c5f0&scoped=true"
import script from "./org_question_list.vue?vue&type=script&lang=js"
export * from "./org_question_list.vue?vue&type=script&lang=js"
import style0 from "./org_question_list.vue?vue&type=style&index=0&id=d8f6c5f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f6c5f0",
  null
  
)

export default component.exports